import { Component, OnInit, OnDestroy, Input,AfterViewInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { PartnerQuestionsService } from '../../../_services/partner-questions.service';

@Component({
  selector: 'app-digitalsignature-dialog',
  templateUrl: './digitalsignature-dialog.component.html',
  styleUrls: ['./digitalsignature-dialog.component.css'],
  providers: [PartnerQuestionsService]

})
export class DigitalsignatureDialogComponent implements OnInit {

  digitalForm: FormGroup;
  digitalFormSub: Subscription;
  partnername;
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors: any;
  loading: boolean;
  partnerid;
  today;
  adult = true;
  todaydate = '';
  required =  true;

  constructor( private _fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private formapi: PartnerQuestionsService,
    public dialogRef: MatDialogRef<DigitalsignatureDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 

      this.partnername = data.partnername;
      this.partnerid = data.partnerid;
      //console.log(this.partnername);
    }

  ngOnInit() {


    let today:any;
    today = new Date();
    let dd:any;
    let mm:any;
    dd = today.getDate();
    mm = today.getMonth()+1; //January is 0!
    let yyyy = today.getFullYear();

    if(dd<10) {
        dd = '0'+dd
    } 

    if(mm<10) {
        mm = '0'+mm
    } 

    this.today = mm + '/' + dd + '/' + yyyy;
    //console.log(this.today);
    
    this.createForm();

  }

  under18() {

    //console.log(this.adult);
    let unsereighteen  = this.digitalForm.controls.unsereighteen.value;
    //console.log(unsereighteen);
    if(unsereighteen){
      this.adult = false;
      this.digitalForm.controls.date.setValue(this.today);
    }
    else {
      this.adult = true;
      this.digitalForm.controls.date.setValue('');
      this.digitalForm.controls.parentName.setValue('');

    }
  }

  agreeTerm1(){

    let studentSignature  = this.digitalForm.controls.studentSignature.value;
    //console.log(studentSignature);
    //if(studentSignature){
      this.required = true;
    //}
  }

  agreeTerm2(){

    let parentSignature  = this.digitalForm.controls.parentSignature.value;
    //console.log(parentSignature);

  }

  createForm()  {

    this.digitalForm  = this._fb.group({
      
      studentName: ['', [Validators.required]],
      dob: [''],
      unsereighteen:[''],
      studentSignature: [''],
      date: [''],
      parentSignature: [''],
      parentName: [''],

    });

    //console.log(this.digitalForm);
    
  }

  onSubmit() {

    this.loading = true;
    const digitalForm = this.digitalForm.value;
    //console.log(digitalForm);

    const body = JSON.stringify({
      studentName: this.digitalForm.controls.studentName.value,
      dob: this.today,
      unsereighteen: this.digitalForm.controls.unsereighteen.value,
      studentSignature: this.digitalForm.controls.studentSignature.value,
      date: this.digitalForm.controls.date.value,
      parentSignature: this.digitalForm.controls.parentSignature.value,
      parentName: this.digitalForm.controls.parentName.value,
      partnerid:this.partnerid
    });

    //console.log(body);

    this.formapi.postDigitalData$(body).subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        this.errorFlag = false;
        const response = JSON.parse(data._body);
        this.successMessage = response.message;
        this.loading = false;
        this.dialogRef.close(response.lastInserted);

      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        const errordata = JSON.parse(error._body);
        if (errordata.success === 0) {
          this.errorMessage = errordata.message;
          this.errorFlag = true;
          this.fieldErrors = errordata.errors;
          this.loading = false;
        }
      },
    );

  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/digitalsignature-dialog/digitalsignature-dialog.component.ts